// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bf_X","index":"styles_index__3L9Yi"};